'use strict';

var ContributingServicesGridTransformerFactory = function ContributingServicesGridTransformerFactory(DataTransformer, momentService) {
  function ContributingServicesGridTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'contributing-services-mode';
    this.targetType = 'contributing-services';
    this.priority = 1;
  }
  ContributingServicesGridTransformer.prototype = Object.create(DataTransformer.prototype);
  ContributingServicesGridTransformer.constructor = ContributingServicesGridTransformer;
  ContributingServicesGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  ContributingServicesGridTransformer.prototype.isCacheable = function () {
    return true;
  };
  ContributingServicesGridTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  ContributingServicesGridTransformer.prototype.transform = function (data) {
    if (data.domain.results) {
      var results = data.domain.results;
      for (var index = 0, dataLength = results.length; index < dataLength; index++) {
        var element = results[index];
        element.market = element.origin + '-' + element.destination;
        element.service = element.serviceId;
        element.applicableDateRangeBegin = momentService.of(element.applicableDateRangeStart, momentService.FIELD.APPLICABLE_DATE_RANGE);
        element.applicableDateRangeEnd = momentService.of(element.applicableDateRangeEnd, momentService.FIELD.APPLICABLE_DATE_RANGE);
        element.lastProcessedDateMoment = momentService.of(element.eventTimeStamp, momentService.FIELD.EVENT_TIME_STAMP);
        element.nbrOfObs = element.traffic;
        if (element.nbrOfObs === null) {
          delete element.nbrOfObs;
        }
        if (element.roundTripIndicator === null) {
          delete element.roundTripIndicator;
        }
      }
      return results;
    } else {
      return [];
    }
  };
  return ContributingServicesGridTransformer;
};
ContributingServicesGridTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = ContributingServicesGridTransformerFactory;